// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "undefined_styles" + "." + "b79ada8d" + ".chunk.css";
};